// Lit imports
import { LitElement, html, css } from 'lit';
import type { CSSResult, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

// DeesComms for push communication
import * as deesComms from '@design.estate/dees-comms';

// Dees-catalog for UI components
import { DeesContextmenu } from '@design.estate/dees-catalog';

export {
  LitElement,
  html,
  css,
  customElement,
  property,
  state,
  deesComms,
  DeesContextmenu,
};

export type { CSSResult, TemplateResult };
